import {fetchSequences} from './fetchSequences.js';
import accounts from "accounts/Accounts.js"
import {SAMPLES, SEQUENCE, MIX} from '../work/types.js';
import sequenceMetadata from "decentralized/sequences/SequenceMetadata.js";
import BackendQuery from 'decentralized/BackendQuery.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';
import {fetchMixes} from './fetchMixes.js';
import {fetchLists} from './fetchLists.js';
import {SampleYoutube} from 'decentralized/EthereumEvents.js';
import {SampleTagged} from 'decentralized/EthereumEvents.js';
import {SampleCreated} from 'decentralized/EthereumEvents.js';

const contract = new GuildSamplesContract();

export const fetchWorks = async (setWorks, setIsFetching, searchOptions, searchTerm, searchTag, guildId, personSelected) => {
    console.log("person selecred == ", personSelected);
    let favorited = searchOptions.includes("Favorited");
    let starred = searchOptions.includes("Starred");
    let sequences =  (await fetchSequences(starred, favorited, searchTerm, searchTag, guildId, personSelected))
          .map(s => ({
              ... s,
              type: SEQUENCE
          }));

    const mixes = await fetchMixes();
    const lists = await fetchLists();
    let list = [... lists, ...mixes, ... sequences];
    list.sort((a, b) => b.blockNumber - a.blockNumber);
    setWorks([...list]);
    setIsFetching(false);
}

const putSamplesIntoBuckets = (samplesFromVideos, allSamples, taggedSamples) => {
    let sampleToTag = {};
    taggedSamples.forEach(s => sampleToTag[s.ipfsHash] = [... (sampleToTag[s.ipfsHash] || []), s.tag]);

    let buckets = {};
    for (let i in allSamples) {
        let sample = allSamples[i];
        let {user, blockNumber} = sample;
        let key = blockNumber;
        if (buckets[key] === undefined) {
            buckets[key] = [];
        }
        if (!buckets[key].some(s => s.ipfsHash === sample.ipfsHash)) {
            buckets[key].push(sample);
        }
    }
    for (let i in samplesFromVideos) {
        let sample = samplesFromVideos[i];
        let {user, blockNumber} = sample;
        let key = blockNumber;
        for (let j in buckets[key]) {
            if (buckets[key][j].ipfsHash === sample.ipfsHash) {
                buckets[key][j].videoId = sample.videoId;
            }
        }
    }
    let bucketedList = [];
    for (let key in buckets) {
        let {user, blockNumber} = buckets[key][0];
        let obj = {
            type: SAMPLES,
            user,
            blockNumber,
            samples: buckets[key],
            tags: [],
        };
        for (let i in buckets[key]) {
            let tags = sampleToTag[buckets[key][i].ipfsHash] || [];
            obj.tags = [... obj.tags, ... tags];
        }
        obj.tags = Array.from(new Set(obj.tags));
        bucketedList.push(obj);
    }
    return bucketedList;
};
